/**
 * Role-based property status labels
 * Admin and Property Owner see different display labels for the same underlying status
 */

/**
 * Get display label for property status based on viewer role
 * @param {string} status - Raw property status (e.g. Inspection_Offer)
 * @param {'admin'|'owner'} viewerRole - Who is viewing: admin (Super Admin/Admin) or owner (Property Owner)
 * @param {object} options - Optional: { hasInspector } for Second_Inspection context
 * @returns {string} User-friendly label
 */
export const getStatusLabel = (status, viewerRole = "admin", options = {}) => {
  const { hasInspector, contractResponse } = options;

  if (!status) return "Unknown";

  if (
    viewerRole === "owner" &&
    status === "Inspection_Offer" &&
    contractResponse === "meeting_requested"
  ) {
    return "Meeting requested";
  }

  const adminLabels = {
    Request_Submission: "Request Submission",
    Pending: "Pending",
    First_Inspection: "Under Inspection",
    Inspection: "Under Inspection",
    Inspection_Offer: "Pending for Approval",
    Inspection_Completed: "Pending for Approval",
    Contracting: "Contracting",
    Preparation: "Preparation",
    Second_Inspection: hasInspector ? "Second Inspection" : "Second Inspection (Assign Inspector)",
    Second_Inspection_Completed: "Second Inspection Completed",
    Legalization: "Legalization",
    Photo_Shooting: "Photo Shooting",
    Active: "Active",
    Approved: "Approved",
    Rejected: "Rejected",
    Disabled: "Disabled",
    Suspended: "Suspended",
    Maintenance: "Maintenance",
  };

  const ownerLabels = {
    Request_Submission: "Under Review",
    Pending: "Under Review",
    First_Inspection: "Inspection Scheduled",
    Inspection: "Inspection Scheduled",
    Inspection_Offer: "Waiting for draft contract approval",
    Inspection_Completed: "Waiting for draft contract approval",
    Contracting: "Contracting",
    Preparation: "Preparation",
    Second_Inspection: "Second Inspection Scheduled",
    Second_Inspection_Completed: "Second Inspection Completed",
    Legalization: "Legalization",
    Photo_Shooting: "Photo Shooting",
    Active: "Active",
    Approved: "Approved",
    Rejected: "Rejected",
    Disabled: "Disabled",
    Suspended: "Suspended",
    Maintenance: "Maintenance",
  };

  const labels = viewerRole === "owner" ? ownerLabels : adminLabels;
  return labels[status] || status.replace(/_/g, " ");
};
